"use client";

import { useRef } from "react";
import AppImage from "@/components/ui/AppImage";
import Icon from "@/components/ui/AppIcon";
import { motion } from "framer-motion";

const testimonials = [
{
  quote: "We switched from two separate sourcing and fulfillment partners to Helium and cut our logistics cost by 31%. More importantly, we stopped spending 3 hours a week chasing updates.",
  author: "Marcus Webb",
  role: "Founder, Luminary Skincare",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1796d0d6c-1763300073910.png",
  metric: "31% cost reduction",
  size: "col-span-2"
},
{
  quote: "The communication is night and day compared to our previous China 3PL. Sophie replies within the hour. Our customers notice the difference in delivery speed.",
  author: "Emma Hartmann",
  role: "Operations Lead, BoldKick Footwear",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14d350b04-1767292815017.png",
  metric: "< 2hr response time",
  size: "col-span-1"
},
{
  quote: "Helium handled our Q4 surge — 4x normal volume — without a single issue. Their tech integrations with Shopify made the whole season seamless.",
  author: "James Okafor",
  role: "CEO, Drift Goods",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15b2ffa8e-1771352207311.png",
  metric: "4x surge capacity",
  size: "col-span-1"
}];


export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  const staggerContainer = {
    initial: {},
    whileInView: {
      transition: {
        staggerChildren: 0.12
      }
    },
    viewport: { once: true, margin: "-50px" }
  };

  const cardVariant = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
  };

  return (
    <section className="py-28 bg-secondary-dark" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          {...fadeInUp}>
          
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-glass-white border border-glass-border text-sm font-medium text-text-secondary backdrop-blur-xl mb-4">
            Social Proof
          </span>
          <h2 className="font-heading font-extrabold text-text-primary mb-4" style={{ fontSize: "clamp(28px, 3.5vw, 44px)", letterSpacing: "-0.02em" }}>
            Brands that made the switch
          </h2>
          <p className="text-lg text-text-secondary max-w-xl mx-auto">
            From 50 orders a month to 50,000 — here's what our partners say after switching to Helium.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
          variants={staggerContainer}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true, margin: "-50px" }}>
          
          {testimonials?.map((t, idx) =>
          <motion.div
            key={idx}
            variants={cardVariant}
            className={`${t?.size} glass-card p-8 group`}>
            
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-accent-primary/30 flex-shrink-0">
                  <AppImage src={t?.avatar} alt={t?.author} width={48} height={48} className="object-cover" />
                </div>
                <div>
                  <div className="font-bold text-text-primary">{t?.author}</div>
                  <div className="text-sm text-text-secondary">{t?.role}</div>
                </div>
                <div className="ml-auto px-3 py-1 rounded-full bg-accent-primary/10 border border-accent-primary/20 text-xs font-semibold text-accent-primary">
                  {t?.metric}
                </div>
              </div>
              <blockquote className="text-text-secondary leading-relaxed mb-4">
                “{t?.quote}”
              </blockquote>
              <div className="flex gap-1">
                {[...Array(5)]?.map((_, i) =>
              <Icon key={i} name="StarIcon" size={16} className="text-accent-primary fill-current" />
              )}
              </div>
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>);


}